module.exports = __webpack_public_path__ + "website/img/computer_4.ac07c065.png";